import { createAsyncThunk } from '@reduxjs/toolkit';
import { makeApiCall } from '../../utils/makeApiCall';
import { serializeError } from '../../utils/errorHandling';

export const getProducts = createAsyncThunk(
  'products/getProducts',
  async (_, { rejectWithValue }) => {
    try {
      return await makeApiCall({
        url: '/products',
        method: 'GET',
      });
    } catch (error) {
      console.error('Failed to fetch products:', error);
      return rejectWithValue(serializeError(error));
    }
  }
);
